import type {
  List as ListType,
  ListItem as ListItemType
} from 'types/capi/content';

import Text from './Text';

type Props = {
  list: ListType;
};

const List = ({ list }: Props) => {
  if (list.list_type === 'ordered')
    return (
      <ol className="list-decimal">
        <ListItems list={list} />
      </ol>
    );

  if (list.list_type === 'unordered')
    return (
      <ul className="list-disc">
        <ListItems list={list} />
      </ul>
    );

  return null;
};

const ListItems = ({ list }: Props) => {
  return (
    <>
      {list.items.map((listItem, index) => (
        <ListItem listItem={listItem} key={index} />
      ))}
    </>
  );
};

function ListItem({ listItem }: { listItem: ListItemType }) {
  return (
    <li>
      {listItem.content.items.map((item, index) => (
        <Text key={index} item={item} />
      ))}
    </li>
  );
}

export default List;
